import defaultLogFormatter from './logFormatter'
/**
 * Default function for the SDK to use for logging.
 *    Uses entry information to form a prefix, then logs to console.
 * @method defaultLogHandler
 * @param  {LogEntry} entry
 */
export default function defaultLogHandler (entry) {
  let { method } = entry

  // For the time-related methods, don't actually use the console methods.
  //    The Logger already did the timing, so simply log out the info.
  if (method.includes('time')) {
    method = 'debug'
  }

  const formattedString = defaultLogFormatter(entry)
  const tail = entry.messages.slice(1)
  console[method](formattedString, ...tail)
}
